import { CountriesResponse, LanguagesResponse } from '@/types/metaData';
import api from '../instance';

export const metaDataService = {
  getLanguagesList: async (): Promise<LanguagesResponse> => {
    try {
      const res = await api.projectApi.get<LanguagesResponse>('/languages', {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching languages list');
    }
  },

  getCountriesList: async (): Promise<CountriesResponse> => {
    try {
      const res = await api.projectApi.get<CountriesResponse>('/location/countries', {
        headers: {
          'x-show-loader': 'true',
          'X-Mm-Service': 'mm-content-mgmt-svc',
        },
      });
      return res.data;
    } catch (error: unknown) {
      if (error instanceof Error) throw error;
      throw new Error('Error fetching countries list');
    }
  },
};
